import ItemCategory from "../../../Models/ItemCategory";
import Mediator from "../../../Utilities/Mediator";
import FastTrackTile from "./FastTrackTile";
import FastTrackItem from "../../../Models/ViewModels/FastTrackItem";

export default class FastTrack {
	top5: HTMLDivElement;
	fastTrackItems: FastTrackItem[];

	constructor(fastTrackItemCategories: Array<ItemCategory>) {
		this.top5 = document.querySelector("#top5");
		this.fastTrackItems = new Array<FastTrackItem>();
		this.top5.style.display = "flex";

		this.ExtractFastTrackItems(fastTrackItemCategories);
		this.addFastTrackListener();
		this.createFastTrackTiles();
	}

	private ExtractFastTrackItems(fastTrackItemCategories: ItemCategory[]) {
		fastTrackItemCategories.forEach(f => {
			f.services.forEach(s => {
				if (s.variants.length > 0) {
					const fastTrackItem = new FastTrackItem();
					fastTrackItem.id = f.id;
					fastTrackItem.name = f.name;
					fastTrackItem.serviceId = s.id;
					fastTrackItem.serviceName = s.name;
					fastTrackItem.variantId = s.variants[0].id;
					fastTrackItem.variantName = s.variants[0].name;
					fastTrackItem.cost = s.variants[0].cost;
					fastTrackItem.baseCost = s.variants[0].baseCost;
					fastTrackItem.productionTime = s.variants[0].productionTime;
					fastTrackItem.productionDepartment = s.variants[0].productionDepartment;
					this.fastTrackItems.push(fastTrackItem);
				}
			});
		});
	}

	private addFastTrackListener() {
		Mediator.on("changeFastTrackStyle", (display: string, opacity: string, pointerEvents: string) => {
			this.top5.style.opacity = opacity;
			this.top5.style.display = display;
			this.top5.style.pointerEvents = pointerEvents;
		});
	}

	private createFastTrackTiles() {
		if (this.fastTrackItems.length > 0) {
			this.top5.innerHTML = "";
			this.top5.classList.add("fast-track");
		}

		for (let i = 0; i < this.fastTrackItems.length; i++) {
			const fastTrackTile = new FastTrackTile(this.fastTrackItems[i]);
			this.top5.appendChild(fastTrackTile.fastTrackTile);
		}
	}
}
